export const cookieManager = {
  set: (name, value, days = 365) => {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    const expires = `expires=${date.toUTCString()}`;
    document.cookie = `${name}=${value};${expires};path=/;SameSite=Strict`;
  },

  get: (name) => {
    const nameEQ = `${name}=`;
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  },

  delete: (name) => {
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
  },

  // Function to set essential cookies only
  setEssentialCookies: () => {
    // Set only cookies required for basic functionality
    cookieManager.set('essential', 'true');
  },

  // Function to set all cookies
  setAllCookies: () => {
    cookieManager.set('essential', 'true');
    cookieManager.set('analytics', 'true');
    cookieManager.set('preferences', 'true');
  },

  // Helper function to check if user has given consent
  hasConsent: (type = 'cookieConsent') => {
    const consent = cookieManager.get(type);
    return consent === 'true';
  },

  // Helper function to check if consent was explicitly withdrawn
  hasWithdrawnConsent: (type = 'cookieConsent') => {
    const consent = cookieManager.get(type);
    return consent === 'false';
  },

  // Helper function to check if consent decision was made (either accepted or withdrawn)
  hasMadeConsentDecision: (type = 'cookieConsent') => {
    const consent = cookieManager.get(type);
    return consent === 'true' || consent === 'false';
  }
}; 